import { ProductExternal } from '@nemuru-eng/js-api-client';

import { AutoLoanListModule } from '@/components/modules/AutoLoanList/AutoLoanList';
import { MetricsProductExternalModule } from '@/components/modules/Metrics/MetricsProductExternal';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES, APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_AUTO_LOAN_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.AUTO_LOAN_LIST,
  showIfAllowedProduct: ApplicationType.AUTO,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'AUTO_LOAN_LIST',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <MetricsProductExternalModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
          }}
          productExternal={ProductExternal.AUTO}
        />
      ),
    },
    {
      textId: undefined,
      module: (
        <AutoLoanListModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
        />
      ),
    },
  ],
};
